
import { mkConfig, generateCsv, download } from 'export-to-csv'; //or use your library of choice here
import { MRT_ColumnDef, MRT_Row } from 'material-react-table';
import { Util } from './Util';
import { Row } from '@tanstack/react-table';

export class UtilCsv {
	static csvConfig = mkConfig({
		fieldSeparator: ',',
		decimalSeparator: '.',
		useKeysAsHeaders: true,
	});


	static handleExportMRTRows = (
		rows: MRT_Row<any>[] | Row<any>[],
		columns: MRT_ColumnDef<any>[],
		filename = 'export',
		dataLabels: any[]
	) => {
		const data = rows.map((row) => {
			const rowData: Record<string, any> = {};
			columns.forEach((col) => {
				let value: any;

				if (col.accessorKey) {
					// Normal key-based access
					value = row.original[col.accessorKey as keyof any];
				} else if (col.accessorFn) {
					// Function-based accessor (MRT supports this)
					const raw = col.accessorFn(row.original);
					value = raw instanceof Date ? Util.formatISODate(raw) : raw;
				}

				rowData[col.header as string] = value ?? "";
			});

			// Ensure 'created', 'updated', and 'description' keys exist
			["created", "updated", "description"].forEach((key) => {
				if (!(key in rowData) && key in dataLabels) {
					rowData[key] = (row.original as any)[key];
				}
			});

			return rowData;
		});

		const csv = generateCsv(UtilCsv.csvConfig)(data);
		download({ ...UtilCsv.csvConfig, filename: filename + "_" + (new Date().toISOString()) })(csv);
	}


	static handleExportData = (data: any, filename = 'export') => {
		const csv = generateCsv(UtilCsv.csvConfig)(data);
		download({ ...UtilCsv.csvConfig, filename: filename + "_" + (new Date().toISOString()) })(csv);
	};
}